<template>
  <tr>
    <td class="text-center align-middle cursor-move">
      <i class="material-icons dnd-icon">dehaze</i>
    </td>
    <td class="align-middle" style="width: 100px;">{{ permissionData.start }}</td>
    <td class="align-middle" style="width: 140px;">{{ permissionData.country.name }}</td>
    <td class="align-middle" style="width: 120px;">{{ permissionData.entry_point }}</td>
    <td class="align-middle" style="width: 100px;">{{ permissionData.eet }}</td>
    <td class="align-middle" style="width: 140px;">{{ permissionData.number }}</td>
    <td class="align-middle" style="width: 100px;">{{ permissionData.validity }}</td>
    <td class="align-middle text-center" style="width: 100px;">
      <span
        v-if="permissionData.country.warnings.length === 0"
        class="text-secondary">
        <i class="material-icons">warning</i> {{ permissionData.country.warnings.length }}
      </span>
      <span
        v-if="permissionData.country.warnings.length > 0"
        class="text-danger">
        <i class="material-icons">warning</i> {{ permissionData.country.warnings.length }}
      </span>
    </td>
    <td class="align-middle text-center spinner-wrapper" style="width: 100px;">
      <span
        v-if="confirmedChangeInProgress"
        class="spinner"></span>
      <span
        v-else
        class="checkbox-wrapper"
        @click.prevent.stop="toggleConfirmedState">
        <d-checkbox
          inline
          :checked="!!permissionData.confirmed" />
      </span>
    </td>
    <td class="align-middle text-center spinner-wrapper" style="width: 100px;">
      <span
        v-if="requestedChangeInProgress"
        class="spinner"></span>
      <span
        v-else
        class="checkbox-wrapper"
        @click.prevent.stop="toggleRequestedState">
        <d-checkbox
          inline
          class="is-warning"
          :checked="!!permissionData.requested" />
      </span>
    </td>
    <td style="width: 140px;" class="align-middle">
      <d-button
        theme="primary"
        @click.prevent="editPermission"
        class="mr-2"
        title="Edit">
        <i class="material-icons">edit</i>
      </d-button>
      <d-button
        theme="danger"
        :disabled="removeInProgress"
        @click.prevent="removePermission"
        title="Delete">
        <i class="material-icons">delete</i>
      </d-button>
    </td>
  </tr>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import ListUtils from './../../utils/ListUtils.js';

export default {
  name: 'permissions-list-item',
  props: {
    referenceId: {
      required: true
    },
    permissionData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {
      removeInProgress: false,
      confirmedChangeInProgress: false,
      requestedChangeInProgress: false
    };
  },
  methods: {
    removePermission () {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/trips/permissions/delete/',
        id: parseInt(this.permissionData.id, 10),
        successTitle: 'Permission removed',
        successText: 'The selected permission has been removed',
        confirmTitle: 'Do you really want to remove this permission?',
        confirmText: 'This operation cannot be reverted',
        errorTitle: 'An error occurred',
        errorText: 'Please try again.',
        successAction: () => {
          this.removeInProgress = false;
          this.$bus.$emit('permissions-list-reload');
        },
        cancelAction: () => {
          this.removeInProgress = false;
        },
        errorAction: () => {
          this.removeInProgress = false;
        }
      });
    },
    editPermission () {
      this.$bus.$emit('show-permission-popup', 'edit', this.permissionData.flight_id, this.permissionData.id);
    },
    toggleConfirmedState () {
      this.confirmedChangeInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/trips/permissions/update/' + this.permissionData.id,
        formData: {
          confirmed: !this.permissionData.confirmed
        },
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during ordering change. Please try again.',
        successAction: (response) => {
          if (response.success) {
            this.permissionData.confirmed = !!response.item.confirmed;
          }

          this.confirmedChangeInProgress = false;
          this.$bus.$emit('flight-details-reload', this.referenceId);
        }
      });
    },
    toggleRequestedState () {
      this.requestedChangeInProgress = true;

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/trips/permissions/update/' + this.permissionData.id,
        formData: {
          requested: !this.permissionData.requested
        },
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during ordering change. Please try again.',
        successAction: (response) => {
          if (response.success) {
            this.permissionData.requested = !!response.item.requested;
          }

          this.requestedChangeInProgress = false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.cursor-move {
  cursor: move;
}

.spinner {
  animation: spinner 1s linear infinite;
  border: 3px solid #ddd;
  border-left-color: #fff;
  border-radius: 50%;
  display: block;
  height: 24px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%) rotate(0deg);
  width: 24px;

  &-wrapper {
    position: relative;
  }
}

.checkbox-wrapper {
  display: block;
  height: 24px;
  left: 50%;
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 24px;

  /deep/ .custom-checkbox {
    left: -8px;
    margin: 0;
    padding: 0;
    position: relative;
  }
}

@keyframes spinner {
  from {
    transform: translateX(-50%) translateY(-50%) rotate(0deg);
  }

  to {
    transform: translateX(-50%) translateY(-50%) rotate(360deg);
  }
}
</style>
